import SectionInfo from 'components/Dashboard/common/SectionInfo'
import Statistics from 'components/Dashboard/cards/common/Statistics'

import classNames from '@ui-components-3/ui/lib/utils/classNames'

type DefaultHeaderProps = {
  title: string
  medicationName: string
  medicationUnit: string
  medicationDirections: string
  quantity: string
  refills: string
  daysSupply: number
  isReady?: boolean
}

const DefaultHeader = ({
  title,
  medicationName,
  medicationUnit,
  medicationDirections,
  quantity,
  refills,
  daysSupply,
  isReady = true,
}: DefaultHeaderProps) => {
  return (
    <div>
      <p className={classNames('typography-body-xxl text-primary-800 tracking-tight', !!isReady && 'mb-4')}>{title}</p>
      {!!isReady && (
        <>
          <SectionInfo title={medicationName} secondLabel={medicationUnit} thirdLabel={medicationDirections} />
          <Statistics quantity={quantity} refills={refills} daysSupply={daysSupply} />
        </>
      )}
    </div>
  )
}

export default DefaultHeader
